import styled from 'styled-components';
import { Link } from 'gatsby';

export const FacilitiesAndServicesSection = styled.div`
  padding: 50px 0;
  background-color: #${({ backgroundColor }) => backgroundColor};

  &#facilitiesAndServices_5 {
    /* padding: 50px 0 0; */

    .description_sub1 {
      font-size: 14px !important;
      max-width: 900px;
      margin-left: auto;
      margin-right: auto;
      letter-spacing: 0px;
      color: #898989;
      margin-bottom: 1.5rem;
    }
  }

  &[dir='rtl'] {
    h3 {
      font-family: GESSTwoDWTCMedium, sans-serif;
    }
  }
`;

export const FacilitiesIcon = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 0 0;
`;

export const IconBlock = styled(Link)`
  width: 25%;
  padding: 3rem 1rem 0;
  text-align: center !important;

  &:hover {
    h3 {
      text-decoration: none;
    }
  }

  @media (max-width: 991.98px) {
    width: 50%;
  }

  @media (max-width: 575.98px) {
    width: 100%;
  }
`;

export const IconDesc = styled.div`
  padding-top: 0px;

  p {
    margin-bottom: 0;
  }
`;

export const IconDescHead = styled.h3`
  text-decoration: underline;
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  margin-bottom: 5px;

  @media (max-width: 1200px) {
    font-size: 18px;
  }

  @media (max-width: 767.98px) {
    font-size: ${({ dir }) => (dir === 'rtl' ? '18px' : '16px')};
  }
`;

export const FacilitiesImageHeader = styled.div`
  height: 80px;

  img {
    display: inline-block;
  }
`;
